import Person from '../utilities/Person'
import DashboardTiles from '../utilities/DashboardTiles'
import { useEffect } from 'react'
import { company } from '../data/AffiliateData'

export default function Dashboard({ setActiveTab, setFilteredLeadStages }) {
    useEffect(() => {
        document.title = `${company.companyName} | Dashboard`
    }, [])

    return (
        <div className='home flex flex-col lg:justify-center lg:items-center'>
            <Person />
            <DashboardTiles 
                setActiveTab={setActiveTab}
                setFilterLeadStages={setFilteredLeadStages}
            />
        </div>
    )
}